module.exports = __webpack_public_path__ + "static/favonius-codex-d1d8f71168aa04ee2abb6edf9a99a3d2.png";